/**
 * License validation disabled for this project.
 * This is a no-op shim that reports the theme as fully licensed so that
 * no license key or store URL needs to be entered in theme settings.
 */
(function () {
  function markLicensed() {
    try {
      var overlay = document.getElementById('license-required-overlay');
      if (overlay) overlay.remove();

      var ids = [
        'license-validation-loading',
        'license-watermark',
        'license-notice',
        'license-tooltip',
        'license-domain-notification',
        'license-suspended-notification',
        'license-revoked-notification',
      ];
      ids.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.remove();
      });

      if (document.body) {
        document.body.classList.remove(
          'theme-unlicensed',
          'license-suspended',
          'license-revoked'
        );
        document.body.classList.add('theme-licensed', 'license-active');
      }
    } catch (e) {}
  }

  var NoopValidator = function () {
    this.isValid = true;
    this.licenseStatus = 'active';
    markLicensed();
  };
  NoopValidator.prototype.isLicenseValid = function () {
    return true;
  };
  NoopValidator.prototype.getLicenseStatus = function () {
    return { valid: true, status: 'active', key: null, domain: null };
  };
  NoopValidator.prototype.validateLicense = function () {};
  NoopValidator.prototype.applyLicenseRestrictions = function () {};
  NoopValidator.prototype.removeLicenseRestrictions = function () {
    markLicensed();
  };
  NoopValidator.prototype.refreshRestrictions = function () {
    markLicensed();
  };

  window.SKIP_LICENSE_OVERLAY = true;
  window.ShopifyLicenseValidator = NoopValidator;
  window.licenseValidator = new NoopValidator();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markLicensed);
  } else {
    markLicensed();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = NoopValidator;
  }
})();
